import styled from '@emotion/styled';

const ShareButton = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 31px;
  width: 31px;
  margin-right: 24px;
  cursor: pointer;
  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    margin-right: 0;
  }

  img {
    width: 24px;
    height: 24px;
  }
`;

export { ShareButton };
